
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-12 flex justify-center items-center">
            <div className="relative w-full flex flex-col items-center">
              {/* Large Text Logo */}
              <h2 className="text-6xl sm:text-8xl md:text-9xl lg:text-[12rem] font-bold tracking-wider" style={{ fontFamily: 'Arial, sans-serif', fontWeight: 900 }}>
                BLECINK
              </h2>
              
              {/* Social Links positioned below logo */}
              <div className="mt-8 flex gap-3">
                <a href="https://www.linkedin.com/company/blecink/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors duration-300 cursor-pointer">
                  <i className="ri-linkedin-fill text-lg text-white"></i>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61583635343300" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors duration-300 cursor-pointer">
                  <i className="ri-facebook-fill text-lg text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-20 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 BlecInk. All rights reserved.
            </p>
            <div className="flex gap-8">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
